import { TFormProps } from "./types";

 export const initialValues: TFormProps = {
    name: "",
    phone: "",
    description: "",
};

export const ERROR_MES = 'Помилка при відправленні'
export const SUCCESS_MES = 'Повідомлення успішно відправлено'